var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9878 0.399994C18.2353 0.365994 18.4168 0.433993 18.6643 0.518993C19.5883 0.841993 20.0338 1.86199 19.7533 2.81399C19.4728 3.74899 18.1033 7.98199 18.1033 8.89999C18.1033 9.80099 19.3408 10.6 20.3308 10.6H25.2808C26.2708 10.6 26.9308 11.28 26.9308 12.3C26.9308 13.32 23.6308 24.2 23.6308 24.2C23.3503 24.863 22.7233 25.9 21.9808 25.9H6.8998V10.6H10.4308C11.1073 9.90299 15.8758 2.59299 16.3378 1.64099C16.6843 0.943994 17.3278 0.484994 17.9878 0.399994ZM0.299805 10.6H3.5998V25.9H0.299805V10.6Z",
    fill: "#709CC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.c78c9b2a676aabb7d68744a6b0803d07.svg";
export { ForwardRef as ReactComponent };